import * as CANNON from 'cannon-es';
import Car from './Car';

import * as THREE from 'three';


class CarEngine {
	// движок
	
//	autoSteering = true; // автоматическое удерживание на трассе
	autoSteering = false; // автоматическое удерживание на трассе
	
	moment = 500; // момент двигателя
	
	brakeForceParking = 1000;  // стояночный тормоз
	brakeForce = 20;  // небольшое торможение при сбросе сцепления
	
	rpmMin = 800;
	rpmMax = 6500;
	rpmLimiter = 6000;  // докуда сбрасываем rpm при достижении rpmMax  
	
	rpmIdleIncreasePercent = 3; // на сколько процентов за цикл инкремента движка увеличивается RPM при разгазовке
	rpmIdleDecreasePercent = 0.7; // на сколько процентов за цикл инкремента движка уменьшается RPM при сбросе разгазовки
	
	airResistCoeff = 0.1;  // коэффициент сопротивления воздуха (множитель к квадрату скорости) 
	rollResistCoef = 0.5;  // коэффициент сопротивления качению (множитель к скорости)
	
	limiterIterations = 100; // сколько времени (в итерациях) удерживаем на отсечке (в движении)

	maxGear =  6; 
	gearMain = 4.353;
	gears: number[] = [-3, 2.643, 2.08, 1.361, 1.024, 0.83, 0.52];
	
	//
//	vehicle: CANNON.RaycastVehicle;
	vehicle: any;

	car: Car;

	keySpace = false;

	gear = 0;  // -1 - задняя передача, 1...N - передние

	clutch = false; // сцепление

	rpm; // текущие обороты
	
	rpmPercentMult;
	
	iteration = 0;
	iterationLimiter = 0;  //  итерация отключения отсечки
	
	keyUpPressed = false;
	keyDownPressed = false;
	
	speed = 0;

	constructor(car: Car, vehicle: CANNON.RaycastVehicle) {
		this.car = car;
		this.vehicle = vehicle; 
		
		// изначально автомобиль на тормозе
		this.car.brakeOn(this.brakeForceParking);

		this.rpm = this.rpmMin;
		
		this.rpmPercentMult = (this.rpmMax - this.rpmMin) / 100; 
		
	}
	/////////////////////////////////////////////////////////
	actionStep(speed: number) {
		// итерация движка; 
		// - текущую скорость получили из CANNON
		// (из разницы позиций за время итерации)
		
		this.speed = speed;
		
		// сила сопротивления воздуха
		const airResistForce = this.airResistCoeff * speed * speed;
		
		// сила сопротивления качению
		const rollResistForce = this.rollResistCoef * speed;
		
		if (this.gear == 0) {
			if (this.keySpace) {
				// газуем на нулевой передаче
				// (быстрый рост rpm до максимального)
				this.rpm += this.rpmIdleIncreasePercent * this.rpmPercentMult; 
				if (this.rpm > this.rpmMax) {
					this.rpm = this.rpmLimiter;
				}
				
			} else {
				// спад rpm до минимального
				if (this.rpm > this.rpmMin) {
					this.rpm -= this.rpmIdleDecreasePercent * this.rpmPercentMult; 
				} else {
					this.rpm = this.rpmMin;
				}
				
			}
			
		} else {
			if (this.clutch) {
				// сцепление включено, едем

				// считаем передаточное число (для оптимизации потом считать только после переключений)
				let multGear = 0;
				if (this.gear == -1) {
					multGear = this.gearMain * this.gears[0];
				} else if (this.gear != 0) {
					multGear = this.gearMain * this.gears[this.gear];
				}
				
				// момент на колёсах, с учётом передаточного числа
				let moment = this.moment * multGear;
				
				// пересчитываем скорость автомобиля в обороты двигателя
				const wheelRadius = this.car.getWheelRadius(); 
				const wheelRpm = 60 * speed / (2 * Math.PI * wheelRadius); 
///				const engineRpm = wheelRpm * multGear;  
				this.rpm = wheelRpm * multGear;  
				
				if (this.iterationLimiter != 0) {
					if (this.iteration >= this.iterationLimiter) {
						this.iterationLimiter = 0;
					}
				}	
					
				let rpmMax;
				if (this.iterationLimiter != 0) {
					// активна отсечка
					rpmMax = this.rpmLimiter;
				} else {
					rpmMax = this.rpmMax;
				}
				
///				if (engineRpm > rpmMax) {
				if (this.rpm > rpmMax) {
					
					if (this.iterationLimiter == 0) {
						// включаем отсечку
						this.iterationLimiter = this.iteration + this.limiterIterations;
					}

					// гасим момент
					
					//if (this.car.carMode == 0) {
					//	moment = -moment / 2;						
					//} else {
						moment = -moment;  // просто обнулять момент - слишком медленно, а так быстро 
					//}
					
				}
				
				
				/*
				const st = document.getElementById("carRpmDebug");
				if (st != null) {
					st.innerHTML = "" + Math.round(engineRpm * 10) / 10;
				}
				*/
				
				this.car.brakeOff();
				
				this.applyWheelMoment(moment);
				
			} else {
				// сцепление отключено, катимся с подтормаживанием
				
				this.car.brakeOn(this.brakeForce);
				
			}
			
		}
		
		let st = document.getElementById("carRpm");
		if (st != null) {
			st.innerHTML = "" + Math.round(this.rpm * 10) / 10;
		}
		
		st = document.getElementById("carGear");
		if (st != null) {
			st.innerHTML = "" + this.gear;
		}

		st = document.getElementById("carClutch");
		if (st != null) {
			st.innerHTML = "" + this.clutch;
		}
		
		if (this.autoSteering) {
			this.autoSteeringAction();
		}
		
		this.iteration++;
		
	}
	/////////////////////////////////////////////////////////
	applyWheelMoment(force: number) {
		
		if (this.car.carMode == 0) {

			this.car.brakeOff();
			
//			const mult = 0.4;
//			const mult = 0.01;
//			const mult = 0.1;
			const mult = 1;
//			const mult = 10;
		
			///this.car.constraintLB.setMotorSpeed(force * mult);
			///this.car.constraintRB.setMotorSpeed(force * mult);
			
			// пробуем двигать за кузов (моторные штуки выше для этого отключаю)
			
			//const v = new CANNON.Vec3(0, 0 , force);
			
//			const euler:CANNON.Vec3 = new CANNON.Vec3();
//			this.car.frameBody.quaternion.toEuler(euler);
//			euler.normalize();
			
			
			
///			const v = new CANNON.Vec3(euler.x * force, euler.y * force , euler.z * force);
			///const v = new CANNON.Vec3(euler.x * force, euler.y * force , euler.z * force);
			
			///this.car.frameBody.force = v;
			
			/*
			// если машина в полёте, то мотор двигать её не может, силу перемещения не применяем
			if (this.car.wheelLBBody.collisionResponse && this.car.wheelRBBody.collisionResponse) {
			
//				const v = new CANNON.Vec3(0, -0.5 * force , -1 * force);
				const v = new CANNON.Vec3(0, 0 , -mult * force);
			
				this.car.frameBody.applyLocalForce(v);
				
			}
			*/

			// пробуем крутить колёса моментом

			//this.car.wheelLFBody.applyTorque(new CANNON.Vec3(-mult * force, 0, 0));
			//this.car.wheelRFBody.applyTorque(new CANNON.Vec3(-mult * force, 0, 0));
			
			// - момент почему-то можно ставить только в абсолютных координатах; придётся разворачивать вектор с учётом направления автомобиля
			const euler:CANNON.Vec3 = new CANNON.Vec3();
			this.car.frameBody.quaternion.toEuler(euler);
			euler.normalize();
			
			//euler.addScaledVector()
			
			let euler2: CANNON.Vec3 = new CANNON.Vec3(-mult * force, 0, 0);
			euler2 = euler2.vmul(euler); 
			
			
			let euler1: THREE.Vector3 = new THREE.Vector3(-mult * force, 0, 0);
//			let euler1: THREE.Vector3 = new THREE.Vector3(-1, 0, 0);
			euler1 = euler1.applyQuaternion(this.car.frameBody.quaternion);
			//euler1 = euler1.  
			
			//euler = CANNON.Vec3.
			
//			const v: CANNON.Vec3 = new CANNON.Vec3(mult * force * euler1.x, mult * force * euler1.y, mult * force * euler1.z); 
//			const v: CANNON.Vec3 = new CANNON.Vec3(euler1.x, euler1.y, euler1.z); 
			const v: CANNON.Vec3 = new CANNON.Vec3(euler2.x, euler2.y, euler2.z); 
			
			
			///this.car.wheelLBBody.applyTorque(v);
			///this.car.wheelRBBody.applyTorque(v);
			
			const lf: CANNON.Vec3 = new CANNON.Vec3(0, 0, mult * force);
			const lp: CANNON.Vec3 = new CANNON.Vec3(0, -0.3, 0);
//			const lp: CANNON.Vec3 = new CANNON.Vec3(0, -0.1, 0);
			
			// пробую вместо приложения глобального момента приложить локальную силу
			this.car.wheelLBBody.applyLocalForce(lf, lp); // localForce, localPoint
			this.car.wheelRBBody.applyLocalForce(lf, lp); // localForce, localPoint
			
			
		} else if (this.car.carMode == 1) {
			this.car.brakeOff();

			this.vehicle.applyEngineForce(force, 2);
			this.vehicle.applyEngineForce(force, 3);
		} else {
			// this.car.carMode == 2

//			const mult = 1;
//			const mult = 2;
///			const mult = 5;
			const mult = 7.5;  // после выравнивания дороги попробовать поднять до 10
//			const mult = 0.5;
//			const mult = 0.75;
//			const mult = 0.1;
///			const mult = 0.25;
//			const mult = 0.01;
//			const mult = 10000000000;
//			const mult = 2;
			
///force = Math.max(force, 100);

			this.vehicle.applyWheelForce(mult * force, 2);
			this.vehicle.applyWheelForce(mult * force, 3);

//			this.vehicle.setWheelForce(mult * force, 2);
//			this.vehicle.setWheelForce(mult * force, 3);

			/*
			this.vehicle.setMotorSpeed(mult * force, 2);
			this.vehicle.setMotorSpeed(mult * force, 3);
			*/
			
			/*
			const mult1 = 20;
			
				const v = new CANNON.Vec3(0, -mult1 * force , -mult * force);
				this.car.frameBody.applyLocalForce(v);
			*/
		}
		
	}
	/////////////////////////////////////////////////////////
	playerControl(action: string) {
		// действия игрока (управление)
		switch(action) {
			case "s+":
				this.keySpace = true;
				if (this.gear != 0) {
					this.clutch = true;
				}
				break;
			
			case "s-":
				this.keySpace = false;
				this.clutch = false;
				break;
			
			case "u+":
				if (!this.keySpace) {
					if (!this.keyUpPressed) {
						if (this.gear < this.maxGear) {
							this.gear++;
						}
					}
				}
				break;
			
			case "u-":
				this.keyUpPressed = false;
				break;
			
			case "d+":
				if (!this.keySpace) {
					if (!this.keyDownPressed) {
						if (this.gear > -1) {
							this.gear--;
						}
					}
				}
				break;
			
			case "d-":
				this.keyDownPressed = false;
				break;
			
		}
		
		
		
		
	}
	/////////////////////////////////////////////////////////
	autoSteeringAction() {
		// автоматическое удерживание на трассе
		const position = this.car.getPhysBodyPosition();
		
/*		
		const quaternion = this.car.getPhysBodyQuaternion();
		
		const euler:CANNON.Vec3 = new CANNON.Vec3();
		quaternion.toEuler(euler);
				
		euler.normalize();
		
		const v = new THREE.Vector3( 0, 0, 1 ).applyQuaternion( quaternion );
//		const v = new CANNON.Vec3( 0, 0, -1 ).applyQuaternion( quaternion );

		const distance1 = -10;

		const farPosition: THREE.Vector3 = new THREE.Vector3( position.x, position.y, position.z).add( v.multiplyScalar( distance1 ) );				
		
//		const pz = ((position.z + shiftZ)/ 4 + 128) * 2 / 256;
		const pz = (farPosition.z / 4 + 128) * 2 / 256;
*/

//		const pz = ((position.z - 2 * this.speed) / 4 + 128) * 2 / 256;
		const pz = ((position.z) / 4 + 128) * 2 / 256;
		
		const roadX = this.car.roadAmplitudeX * this.car.noise2D(pz / 4, 0);
		
		const st = document.getElementById("carAutoSteering");
		
		//const a = (position.x - roadX) / 100;
		//this.car.rightVelocity += a;
		
		if (position.x < roadX) {
			this.car.rightVelocity -= 0.5 / (this.speed + 5);
			
			if (this.car.rightVelocity <= -0.5) {
				this.car.rightVelocity = -0.5;
			}
			
			
			if (st != null) {
				st.innerHTML = "вправо";
			}
			
		} else if (position.x > roadX) {
			this.car.rightVelocity += 0.5 / (this.speed + 5);

			if (this.car.rightVelocity >= 0.5) {
				this.car.rightVelocity = 0.5;
			}
			
			if (st != null) {
				st.innerHTML = "влево";
			}

		} else {
			this.car.rightVelocity = 0;
			if (st != null) {
				st.innerHTML = "-";
			}
		}
		
	}	
	/////////////////////////////////////////////////////////
	switchAutoSteering(autoSteeringChecked: boolean) {
		this.autoSteering = autoSteeringChecked;
	}
	/////////////////////////////////////////////////////////
	
	
}
export default CarEngine;